var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Equipo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.55 45.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.78,
    cy: 22.78,
    r: 22.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-2337.08-1003.91a15.92,15.92,0,0,0-10.06-6.73,13.56,13.56,0,0,0-1.4-.22l-.67-.08-.21,0-.1,0h-1.91l-.59.08c-.41,0-.84.1-1.26.18a16.07,16.07,0,0,0-9.79,5.75,16.16,16.16,0,0,0-3.6,8.62c0,.16,0,.31,0,.47l0,.22v1.91c0,.19,0,.39.07.58.05.42.1.85.18,1.26a16.08,16.08,0,0,0,5.76,9.8,15.62,15.62,0,0,0,8.6,3.58,17,17,0,0,0,1.73.09,15.74,15.74,0,0,0,10.39-3.85,15.7,15.7,0,0,0,5.43-9A15.76,15.76,0,0,0-2337.08-1003.91Zm-27.61,8.16a14,14,0,0,1,2.77-7.47,14.23,14.23,0,0,1,2.73,7.47Zm13.2,2v13.2a14.19,14.19,0,0,1-9.09-4.17,16.49,16.49,0,0,0,3.41-9Zm0-15.21v13.17h-5.68a16.4,16.4,0,0,0-3.4-9C-2359-1006.8-2354.06-1009.07-2351.49-1008.92Zm-7.7,15.22a14.27,14.27,0,0,1-2.73,7.47,14.09,14.09,0,0,1-2.77-7.47Zm22.94-2h-5.51a14.24,14.24,0,0,1,2.73-7.48A14.17,14.17,0,0,1-2336.25-995.74Zm0,2a14,14,0,0,1-2.77,7.47,14.25,14.25,0,0,1-2.73-7.47Zm-13.19-2v-13.21a14.19,14.19,0,0,1,9.08,4.17,16.49,16.49,0,0,0-3.41,9Zm5.67,2a16.46,16.46,0,0,0,3.4,9c-1.53,2-6.48,4.3-9.08,4.16v-13.17Z",
    transform: "translate(2373.25 1017.51)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Equipo2);
export default __webpack_public_path__ + "static/media/1_Equipo2.3330263222f327630c65f5affee9fe3c.svg";
export { ForwardRef as ReactComponent };